const lakStorageSystem = `

#### What is Lak Storage?
- The **Lak Storage System** allows you to **temporarily export Lak from your necklace** using an item called **Lak Transmitter**.
- This feature enables players to **switch necklaces** while in a Dungeon Party (**DP**).

#### Storage Capacity
- **Lakstorage - Bronze**: **500,000,000 Lak** ![Bronze](http://i.epvpimg.com/8Aq8cab.jpg)
- **Lakstorage - Silver**: **1,000,000,000 Lak** ![Silver](http://i.epvpimg.com/MC5Faab.jpg)
- **Lakstorage - Gold**: **2,000,000,000 Lak** ![Gold](http://i.epvpimg.com/MRpmeab.jpg)

⚠️ Currently, only the **Bronze Storage** is available. Higher-tier storage options will be **unlocked in future updates**.

#### Checking Your Lak Storage
- **Double-click** your storage to **view current Lak balance** and **maximum capacity**.
![Lak Storage UI](http://i.epvpimg.com/ci2bcab.png)

#### Extracting Lak from Your Necklace
- **Required Item**: ![Lak Transmitter](http://i.epvpimg.com/d59pbab.jpg) **Lak Transmitter**
- **How to use**: **Double-click** the transmitter to seal monster souls into storage.

---

### Ways to Use Stored Lak
#### 1️⃣ **Jewelry Restoration**
- Use stored Lak to **restore the lost power of your Soulstones** on **all equipped items**.
- Requires **sufficient Lak stored**.

#### 2️⃣ **Lak Trader - Convert Lak to Rupees**
- Exchange Lak for **rupees** via the **Lak Trader**.
- ⚠️ **Conversion rate differs** from the normal exchange rate!
- **Titles also work**, but with **reduced benefits** due to processing costs.

🔹 **More ways to use stored Lak will be added in future updates!**

Enjoy this new feature and have fun! 🎉`;

export default lakStorageSystem;
